import { request } from '../utils/request';

export const fetchClusterHubsApi = () => request.get('/admin/cluster-hubs');

export const openHubAPI = data => request.post('/admin/open-hub', data);

